import { useUserHasAccess } from "hooks/useUserHasAccess";

export function useDocumentSettings() {

    const userHasAccess = useUserHasAccess();

    const isManager = userHasAccess("Documents:Manage");

    const defaultPath = isManager ? "/document-settings/types" : "/document-settings/documents";

    return {
        isManager,
        defaultPath
    }
};